export default __webpack_public_path__ + "static/media/b0ab161f-4dc8-412e-8b6d-89a98e04c3e1.43391aa1.eot";